import { Icon } from '../Icon/Icon';
import * as styles from './ArrowIcon.css';

export interface CommonIconProps {
  readonly disabled?: boolean;
}

export const ArrowIcon: React.FC<CommonIconProps> = ({ disabled }) => {
  return (
    <span aria-hidden="true" className={styles.caretIcon}>
      <Icon data-testid="arrow-icon-wrapper" name="dropdown" size="md" variant={disabled ? 'disabled' : 'secondary'} />
    </span>
  );
};
